import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconBitbucketColor16 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#2684FF",
			d: "M1.45 1.7c-.28 0-.49.256-.443.513l1.888 11.562a.604.604 0 0 0 .606.513h9.138a.47.47 0 0 0 .443-.373l1.911-11.679a.437.437 0 0 0-.442-.513zm8.019 8.346H6.555l-.77-4.127h4.406z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#a)",
			d: "M14.364 5.92h-4.196l-.7 4.126H6.556l-3.427 4.08s.163.139.396.139h9.138a.47.47 0 0 0 .443-.373z"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			x1: 15.346,
			x2: 8.392,
			y1: 7.082,
			y2: 12.51,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .176,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgIconBitbucketColor16);
export default ForwardRef;
